module.exports = "/packs/001-afa203e6911dcf7720941737c7e9544d.jpg";